import { Loader, PageWrapper } from '@/shared'
import { useDragAndDrop } from '@App/hooks'
import { type ISwapSequencs } from '@App/types/common'
import { type IEditFaq, type IFaqData } from '@App/types/faqTypes'

import style from './FaqListWrapper.module.scss'
import { List } from './List/List'

interface IProps {
    list: IEditFaq[] | null
    onSwapBySequence: (dto: ISwapSequencs) => void
    onGetUnchangedFaqItemById: ({ id }: { id: string }) => void
    setFaqEditableState: (data: IEditFaq[] | null) => void
    updateFaqList: (dto: IFaqData) => void
    removeFaqById: (faqId: string) => void
}

export const FaqListWrapper = (props: IProps) => {
    const { list, updateFaqList, removeFaqById, setFaqEditableState, onGetUnchangedFaqItemById, onSwapBySequence } =
        props

    const {
        highlited,
        currentItem,
        setHighlited,
        onDragStartHandler,
        onDragLeaveHandler,
        onDragEndHandler,
        onDragOverHandler
    } = useDragAndDrop()

    const onDropHandler = (e: any, item: IEditFaq) => {
        e.preventDefault()
        setHighlited(null)
        if (currentItem && currentItem.id !== item.id) {
            const dto = {
                srcId: currentItem.id,
                destId: item.id
            }
            onSwapBySequence(dto)
        }
    }

    return (
        <PageWrapper>
            {list && (
                <List
                    setFaqEditableState={setFaqEditableState}
                    list={list}
                    onGetUnchangedFaqItemById={onGetUnchangedFaqItemById}
                    updateFaqList={updateFaqList}
                    removeFaqById={removeFaqById}
                    onDragStartHandler={onDragStartHandler}
                    onDragLeaveHandler={onDragLeaveHandler}
                    onDragEndHandler={onDragEndHandler}
                    onDragOverHandler={onDragOverHandler}
                    onDropHandler={onDropHandler}
                    highlited={highlited}
                />
            )}
            {!list && (
                <div className={style.loaderWrapper}>
                    <Loader />
                </div>
            )}
        </PageWrapper>
    )
}
